import { get } from './base';

const getFeatureFlags = async () => get('api/configuration');

export default getFeatureFlags;
